<path
    d="M42.875 3C45.1532 3 47 4.8468 47 7.125V31.875C47 34.1532 45.1532 36 42.875 36H18.125C15.8468 36 14 34.1532 14 31.875V7.125C14 4.8468 15.8468 3 18.125 3H42.875ZM18.125 38.75C14.3341 38.75 11.25 35.6659 11.25 31.875V14H7.125C4.8468 14 3 15.8468 3 18.125V42.875C3 45.1532 4.8468 47 7.125 47H31.875C34.1532 47 36 45.1532 36 42.875V38.75H18.125Z"
    fill="currentColor"
/>
